module.exports = __webpack_public_path__ + "static/img/8.63c3f22.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/zh/8.png
// module id = m9fk
// module chunks = 0